<template>
  <v-card>
    <v-overlay
        v-model="showPhotoOverlay"
        scroll-strategy="block"
        :close-on-content-click="$vuetify.display.mdAndDown"
        location-strategy="connected"
        class="align-center justify-center"
    >
      <v-row no-gutters="true">
        <v-virtual-scroll
            class="h-screen"
            :items="photos"
        >
          <template v-slot:default="{ item }">
            <v-img
                :src="item"
                :eager="true"
                :min-height="$vuetify.display.mdAndUp ? 450 : 250"
                :min-width="$vuetify.display.mdAndUp ? 900 : 400"
            />
          </template>
        </v-virtual-scroll>
        <v-btn
            class="justify-end"
            color="black"
            icon="mdi-close"
            @click="showPhotoOverlay=false"
        />
      </v-row>
    </v-overlay>
    <v-card-item>
      <v-row>
        <v-col>
          <p class="text-h5 text-no-wrap">{{ title }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-divider v-if="$vuetify.display.mdAndUp"/>
      </v-row>
      <v-row>
        <v-col v-if="$vuetify.display.mdAndUp" cols="6">
          <carousel
              id="gallery"
              :items-to-show="1"
              v-model="currentSlide"
          >
            <slide
                v-for="item in photos"
                :key="item"
            >
              <v-img
                  :max-height="$vuetify.display.lgAndUp ? 450 : 400"
                  :src="item"
                  :eager="true"
                  :cover="true"
                  class="mb-1"
                  @click="showPhotoOverlay = !showPhotoOverlay"
              />
            </slide>
            <template>
              <Navigation/>
            </template>
          </carousel>
          <carousel
              id="thumbnails"
              :items-to-show="4"
              v-model="currentSlide"
              ref="carousel"
          >
            <slide
                v-for="(item, index) in photos"
                :key="item"
            >
              <v-img
                  :src="item"
                  :eager="true"
                  :cover="true"
                  class="mx-1"
                  @click="slideTo(index)"
              />
            </slide>
          </carousel>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
          <v-row>
            <v-col v-if="$vuetify.display.smAndDown" cols="12">
              <carousel
                  id="gallery"
                  :items-to-show="1"
                  v-model="currentSlide"
              >
                <slide
                    v-for="item in photos"
                    :key="item"
                >
                  <v-img
                      :max-height="$vuetify.display.lgAndUp ? 450 : 400"
                      :src="item"
                      :eager="true"
                      :cover="true"
                      class="mb-1"
                      @click="showPhotoOverlay = !showPhotoOverlay"
                  />
                </slide>
              </carousel>
              <carousel
                  id="thumbnails"
                  :items-to-show="4"
                  v-model="currentSlide"
                  ref="carousel"
              >
                <slide
                    v-for="(item, index) in photos"
                    :key="item"
                >
                  <v-img
                      :src="item"
                      :eager="true"
                      :cover="true"
                      class="mx-1"
                      @click="slideTo(index)"
                  />
                </slide>
              </carousel>
            </v-col>
          </v-row>
          <v-row>
            <v-divider/>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <p class="text-h6">Specification</p>
              <p class="font-weight-medium">Year: <span class="font-weight-regular">{{ year }}</span>
              </p>
              <p class="font-weight-medium">Engine: <span class="font-weight-regular">{{ engine }}cc</span></p>
              <p class="font-weight-medium">Fuel: <span class="font-weight-regular">{{ fuel }}</span>
              </p>
              <p class="font-weight-medium">Transmission: <span
                  class="font-weight-regular">{{ transmission }}</span></p>
              <p class="font-weight-medium">Color: <span class="font-weight-regular">{{ color }}</span></p>
              <p class="font-weight-medium">Mileage: <span
                  class="font-weight-regular">{{ mileage }} km</span></p>
              <p class="font-weight-medium">Specification: <span
                  class="font-weight-regular">{{ specification }}</span>
              </p>
            </v-col>
            <v-col cols="12" md="1">
              <v-divider
                  class="fill-height"
                  :vertical="$vuetify.display.mdAndUp"/>
            </v-col>
            <v-col
                cols="12"
                md="5"
                class="text-center"
            >
              <h3 class="text-center font-weight-bold">
                Price(exw.)
                <v-tooltip text="The price paid for the product ex-works (i.e. when it leaves the factory)">
                  <template v-slot:activator="{ props }">
                    <v-btn
                        v-bind="props"
                        icon="mdi-help"
                        size="x-small"
                        variant="plain"
                        class="pb-1"
                    />
                  </template>
                </v-tooltip>
              </h3>

              <p class="text-center font-weight-regular">{{ firstPrice }}</p>
              <p class="text-center font-weight-regular mx-3">{{ secondPrice }}</p>
              <p class="text-center font-weight-regular">{{ thirdPrice }}</p>
              <p class="text-center font-weight-regular text-subtitle-2 mb-3">(Price in Korea)</p>
              <v-btn
                  v-if="isAuthorized && !isRequested"
                  :loading="isRequestSent"
                  :disabled="isRequestSent"
                  class="mb-1 mr-2"
                  size="large"
                  @click="initiateRequest"
              >
                Buy
              </v-btn>
              <v-btn
                  v-if="isAuthorized && !isRequested && isCheckupVisible"
                  class="mb-1"
                  size="large"
                  @click="checkUp"
              >
                CheckUp
              </v-btn>
              <br v-if="!isRequested"/>
                <v-btn
                    class="mb-1"
                    size="large"
                    @click="contactUs"
                >
                  Contact Us
                </v-btn>
              <p v-if="isAuthorized"
                 class="text-center font-weight-regular text-subtitle-2"
                 v-text="isRequested ? 'Car already requested, please, consider another one' : 'Send request to get final price to your country!'"/>
              <p v-else
                 class="text-center font-weight-regular text-subtitle-2"
              >
                You need to sign-in to request a car.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row>
        <v-col>
          <v-expansion-panels
              v-model="expandStates"
              multiple="true"
          >
            <v-expansion-panel
                elevation="0"
            >
              <v-expansion-panel-title class="px-2">
                <p class="text-h6">Similar cars</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <car-ad-list
                    :cars="carAdList"
                    @load-car-ads="$emit('loadCarAds', $event)"
                />
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel
                elevation="0"
            >
              <v-expansion-panel-title class="px-2">
                <p class="text-h6">Specification details</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <car-specification-details :equipment-groups="equipmentGroups"/>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-divider/>
      </v-row>
      <v-row class="px-2">
        <v-col>
          <h3>Description</h3>
          <p class="font-weight-regular">
            {{ description }}
          </p>
        </v-col>
      </v-row>
    </v-card-item>
  </v-card>
</template>

<script>

import 'vue3-carousel/dist/carousel.css'
import {Carousel, Slide, Navigation} from 'vue3-carousel'
import CarSpecificationDetails from "@/components/Car/CarSpecificationDetails.vue";
import CarAdList from "@/components/Car/CarAdList.vue";

export default {
  name: "CarCard",
  emits: ['loadCarAds'],
  components: {CarAdList, CarSpecificationDetails, Carousel, Slide, Navigation},
  props: {
    title: String,

    photos: Array,

    year: String,
    engine: String,
    fuel: String,
    transmission: String,
    color: String,
    mileage: String,
    specification: String,

    firstPrice: String,
    secondPrice: String,
    thirdPrice: String,
    isAuthorized: Boolean,
    contactUs: Function,
    isCheckupVisible: Boolean,
    checkUp: Function,
    sendRequest: Function,
    isRequested: Boolean,

    carAdList: Array,
    onLoadAds: Function,

    equipmentGroups: Object,

    description: String,
  },
  data() {
    return {
      currentSlide: 0,
      showPhotoOverlay: false,
      expandStates: [0, 1],
      isRequestSent: false,
    }
  },
  methods: {
    async initiateRequest() {
      this.isRequestSent = true
      await this.sendRequest()
      this.isRequestSent = false

    },
    slideTo(index) {
      this.currentSlide = index
    }
  },
}
</script>

<style scoped>

</style>